var map = {
	"./cs.json": [
		64212,
		64212
	],
	"./de.json": [
		69221,
		69221
	],
	"./en.json": [
		48041,
		48041
	],
	"./es.json": [
		74906,
		74906
	],
	"./fr.json": [
		90322,
		90322
	],
	"./it.json": [
		73451,
		73451
	],
	"./ja.json": [
		35775,
		35775
	],
	"./ko.json": [
		26904,
		26904
	],
	"./pl.json": [
		99422,
		99422
	],
	"./pt-br.json": [
		48937,
		48937
	],
	"./pt.json": [
		37638,
		37638
	],
	"./ru.json": [
		21947,
		21947
	],
	"./tr.json": [
		52644,
		52644
	],
	"./zh.json": [
		2324,
		2324
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 16915;
module.exports = webpackAsyncContext;